module.exports = __webpack_public_path__ + "static/media/wabe.1c81bfe1.jpg";